


export default ()=>{
    return <div style={{background:"#353945", height:"1rem",width:"100%", position:"absolute", top:0, left:"0", zIndex:"-1"}}></div>
}